<template>
<div class="component">
    <div class="surveyHeader">
        <div class=" surveyTitleContainer" :style="surveyTitleStyle()">
            <div class="surveyTitleContentContainer">
                <div class="surveyIcon"><i class="fas fa-user-edit"></i></div>
                <div class="surveyTitle">{{survey.title}}</div>
            </div>
        </div>

    </div>

    <div v-if="survey.isOpen==1">
        <showQuestion v-for="question in survey.questions" :question="question"></showQuestion>
    </div>
    <div v-else>
        <showQuestionResult v-for="result in surveyResults.questions" :question="result"></showQuestionResult>

    </div>
    <div class=""><span class="button is-large is-info" @click="$emit('close')">{{$t('enaq_translation_surveys_back')}}</span></div>

</div>
</template>

<script>
import showQuestion from '@/components/Surveys/User/showQuestion.vue';
import showQuestionResult from '@/components/Surveys/User/showQuestionResult.vue';

export default {
    name: 'survey',
    props: ["surveyId"],
    components: {
        showQuestion,
        showQuestionResult
    },
    mounted: function () {
        this.getSurvey();
        if (this.survey.isOpen != 1) {
            this.getSurveyResults();
        }
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            survey: {},
            surveyResults: {},
        }
    },
    methods: {

        getSurvey() {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/survey/" + this.surveyId, {
                headers: headerData
            }).then(function (response) {

                this.survey = response.data.survey[0]
            }.bind(this))

        },
        getSurveyResults() {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/survey/result/" + this.surveyId, {
                headers: headerData
            }).then(function (response) {

                this.surveyResults = response.data.results
            }.bind(this))

        },
        surveyTitleStyle() {
            let backgroundColors = ['#FFC400', '#00EC94', '#F80084', '#4C39FF']
            let bgColor = '#9792A8'
            if (this.survey.isOpen) {
                bgColor = backgroundColors[Math.floor(Math.random() * backgroundColors.length)]
            }

            return {
                'background': bgColor
            }
        },
        closeSurvey() {
            this.$emit("close")
        }
    },
    computed: {},
}
</script>

<style scoped>
.surveyTitle {
    font-size: 3.2em;
    color: white;
    font-weight: bolder;
    display: inline-block;
    width: 75%;
    text-align: left;
    padding-right: 8vw;
    max-width:75%;
    padding-right: 2%;
}

.surveyIcon {
    display: inline-block;
    width: 25%;
    line-height: 25vh;
    font-size: 15.5em;
    text-align: left;
    padding-left: 5%;
    margin-top: -5vh;

    color: black;
}

.surveyTitleContainer {
    width: 120vw;
    margin-left: -15vw;
    height: 25vh;
    max-height: 25vh;
    margin-top: 5vh;
    margin: 1vh 0 10vh -15vh;
    transform: rotateZ(-2deg)
}

.surveyTitleContentContainer {
    transform: rotateZ(2deg);

    max-height: 9vh;

}
</style>
